import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Checkbox } from '../../ui/checkbox';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../ui/dialog';

const SaveViewDialog = ({
  open, onOpenChange,
  pathLabel, pathname, search,
  name, setName,
  shared, setShared,
  autoSlug, setAutoSlug,
  canShare,
  saving,
  onSubmit,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="save-view-dialog">
      <DialogHeader>
        <DialogTitle>Save this view</DialogTitle>
        <DialogDescription>
          Bookmark the current filter combination on{' '}
          <span className="font-medium">{pathLabel}</span> for one-click return.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-2">
        <div className="space-y-1.5">
          <Label htmlFor="view-name">View name</Label>
          <Input
            id="view-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Q2 HVAC priority work"
            autoFocus
            data-testid="save-view-name-input"
          />
        </div>
        <div className="rounded-md border bg-muted/40 p-3">
          <p className="text-[11px] uppercase tracking-wide text-muted-foreground mb-1">
            Filters captured
          </p>
          <code className="text-xs text-[#111565] break-all">
            {pathname}{search || ' (no filters)'}
          </code>
        </div>
        <label className="flex items-start gap-2 cursor-pointer">
          <Checkbox
            id="auto-slug-toggle"
            checked={autoSlug}
            onCheckedChange={(v) => setAutoSlug(Boolean(v))}
            data-testid="save-view-auto-slug-toggle"
          />
          <div className="space-y-0.5">
            <span className="text-sm font-medium">Create a permalink</span>
            <p className="text-xs text-muted-foreground">
              Generates a short shareable URL like <code>/v/your-view</code>; copied to clipboard on save.
            </p>
          </div>
        </label>
        {canShare && (
          <label className="flex items-start gap-2 cursor-pointer">
            <Checkbox
              id="shared-toggle"
              checked={shared}
              onCheckedChange={(v) => setShared(Boolean(v))}
              data-testid="save-view-shared-toggle"
            />
            <div className="space-y-0.5">
              <span className="text-sm font-medium">Share with team</span>
              <p className="text-xs text-muted-foreground">
                Everyone with access to this page will see the view in their list.
                Only you can delete it.
              </p>
            </div>
          </label>
        )}
      </div>
      <DialogFooter>
        <Button
          variant="outline"
          onClick={() => onOpenChange(false)}
          disabled={saving}
          data-testid="save-view-cancel-btn"
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          disabled={saving}
          className="bg-[#111565] hover:bg-[#111565]/90"
          data-testid="save-view-submit-btn"
        >
          {saving ? 'Saving…' : 'Save view'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default SaveViewDialog;
